import { convertDateToISOString, setCurrencyFormat } from 'src/utils/util';
import { getPriceInNumberDataType } from './dataModificaionUtil';
import i18n from 'src/i18n.js';
 
const t = (key) => i18n.t(key);
export const getModifiedButtonVisibilities = (
    footerButtonStatuses,
    btn1,
    btn2,
    fromProgressBar
) => {
    let modifiedButtonStatuses = [...footerButtonStatuses];
    if (fromProgressBar) {
        modifiedButtonStatuses = modifiedButtonStatuses.map((x) =>
            x.btnName !== t('equity.equityFooter.cancelButton') && x.btnName !== t('equity.equityFooter.saveAndExitButton')
                ? { ...x, btnVisibility: false }
                : x
        );
    }
    const btn1Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn1);
    if (btn1Idx >= 0) {
        modifiedButtonStatuses[btn1Idx].btnVisibility = false;
    }
    const saveExitBtnIdx = modifiedButtonStatuses.findIndex(
        (x) => x.btnName === t('equity.equityFooter.saveAndExitButton')
    );
    if (saveExitBtnIdx >= 0) {
        modifiedButtonStatuses[saveExitBtnIdx].btnVisibility =
            btn2 === t('equity.equityFooter.applyButton') ? false : true;
    }
    const btn2Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn2);
    if (btn2Idx >= 0) {
        modifiedButtonStatuses[btn2Idx].btnVisibility = true;
    }
    return modifiedButtonStatuses;
};

export const calculateDiscountPercentage = (originalPrice, adjustedPrice) => {
    const discount =
        originalPrice > 0 ? (originalPrice - adjustedPrice) / originalPrice : 0;
    return (discount * 100).toFixed(2);
};

export const calculateAdjustedPrice = (originalPrice, discount) => {
    const adjustedPrice = (originalPrice * (100 - discount)) / 100;
    return adjustedPrice;
};

export const checkIfValidQuantities = (qty) => {
    const usedQty = qty.used || qty.Used || qty.usedQuantity;
    const otherQty = qty.other || qty.Other;
    if (
        usedQty &&
        (typeof usedQty === 'string' || typeof usedQty === 'number')
    ) {
        return parseInt(usedQty) > 0;
    } else if (
        otherQty &&
        (typeof otherQty === 'string' || typeof otherQty === 'number')
    ) {
        return parseInt(otherQty) > 0;
    } else if (usedQty === true || otherQty === true) {
        return true;
    } else {
        return false;
    }
};

export const checkIfValidPricedItems = (itemTableData, isForPriceOverride) =>
    itemTableData &&
    itemTableData.length > 0 &&
    itemTableData.every(
        (item) =>
            !item.isInvalidItemMsg &&
            item.basePrice &&
            getPriceInNumberDataType(item.basePrice) >= 0 &&
            item.lotSerial &&
            item.lotSerial.length > 0 &&
            item.lotSerial.every(
                (qty) =>
                    (isForPriceOverride ? true : !qty.isInvalidLotSerialMsg) &&
                    !qty.isInvalidQtyMsg &&
                    checkIfValidQuantities(qty)
            ) &&
            (item.isBundleItem
                ? !item.noItemInBundleErr &&
                  item.children?.length > 0 &&
                  item.children.every(
                      (child) =>
                          !child.isInvalidItemMsg &&
                          Object.prototype.hasOwnProperty.call(
                              child,
                              'basePrice'
                          ) &&
                          child.lotSerial &&
                          child.lotSerial.length > 0 &&
                          child.lotSerial.every(
                              (qty) =>
                                  (isForPriceOverride
                                      ? true
                                      : !qty.isInvalidLotSerialMsg) &&
                                  !qty.isInvalidQtyMsg &&
                                  checkIfValidQuantities(qty)
                          )
                  )
                : !item.children)
    );

export const validateReportPaymentItem = (itemTableData) => {
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every((item) => {
            return (
                !item.isInvalidItemMsg &&
                getPriceInNumberDataType(item.unitPrice) >= 0 &&
                !item.isPoImageError &&
                !item.isInvalidLotSerialMsg &&
                !item.isInvalidQtyMsg &&
                (parseInt(item.usedQuantity) > 0 ||
                    parseInt(item.otherQuantity) > 0 ||
                    item.usedQuantity === true ||
                    item.otherQuantity === true)
            );
        })
    );
};

export const getTotalUsedQuantity = (lotSerialArr) => {
    const usedQuantityArr =
        lotSerialArr &&
        Array.isArray(lotSerialArr) &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const usedQty = x.used || x.Used;
                return usedQty === true ? 1 : parseInt(usedQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return usedQuantityArr && usedQuantityArr.length > 0
        ? usedQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getTotalUsedTissueItemQuantity = (lotSerialArr) => {
    const usedQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x.used === true || x.Used === true);
    return usedQuantity && usedQuantity.length;
};

export const getTotalOtherTissueItemQuantity = (lotSerialArr) => {
    const otherQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x.other === true || x.Other === true);
    return otherQuantity && otherQuantity.length;
};

export const getTotalOtherQuantity = (lotSerialArr) => {
    const otherQuantityArr =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const otherQty = x.other || x.Other;
                return otherQty === true ? 1 : parseInt(otherQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return otherQuantityArr && otherQuantityArr.length > 0
        ? otherQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getQuantity = (itemTableData, filterType) => {
    if (filterType === 'nonTissue') {
        return itemTableData
            .filter((item) => item.salesOrg !== 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue +
                    parseInt(currentValue.quantity ? currentValue.quantity : 0),
                0
            );
    } else if (filterType === 'tissue') {
        return itemTableData
            .filter((item) => item.salesOrg === 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue +
                    parseInt(currentValue.quantity ? currentValue.quantity : 0),
                0
            );
    }
    return 0;
};
export const getTotalQuantity = (lotSerialArr) => {
    let totalQuantity = 0;
    if (lotSerialArr && lotSerialArr.length > 0) {
        const usedQuantity = getTotalUsedQuantity(lotSerialArr)
            ? getTotalUsedQuantity(lotSerialArr)
            : 0;
        const otherQuantity = getTotalOtherQuantity(lotSerialArr)
            ? getTotalOtherQuantity(lotSerialArr)
            : 0;
        totalQuantity = usedQuantity + otherQuantity;
    }
    return totalQuantity;
};

export const priceFormatObj = {
    style: 'currency',
    currency: localStorage.getItem('currencyISOCode'),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const getTotalExtendedPrice = (adjBasePrice, lotSerialArr, qtyType) => {
    let extendedPrice = setCurrencyFormat(0),
        quantity = 0;
    if (qtyType === 'used') {
        quantity = getTotalUsedQuantity(lotSerialArr);
    } else if (qtyType === 'other') {
        quantity = getTotalOtherQuantity(lotSerialArr);
    } else if (qtyType === 'total') {
        quantity = getTotalQuantity(lotSerialArr);
    }
    if (adjBasePrice && quantity > 0) {
        extendedPrice = setCurrencyFormat(
            getPriceInNumberDataType(adjBasePrice) * quantity
        );
    }
    return adjBasePrice ? extendedPrice : '';
};
export const getTotalExtendedPriceRP = (adjBasePrice, qty, qtyType) => {
    let extendedPrice = setCurrencyFormat(0),
        quantity = 0;
    if (qtyType === 'used') {
        const uQty = qty;
        quantity = uQty;
    } else if (qtyType === 'other') {
        const oQty = qty;
        quantity = oQty;
    }
    if (adjBasePrice && quantity > 0) {
        extendedPrice = setCurrencyFormat(
            getPriceInNumberDataType(adjBasePrice) * quantity
        );
    }
    return adjBasePrice ? extendedPrice : '';
};

export const flattenLotSerialArrayOfArrays = (filterType, items) => {
    if (filterType === 'nonTissue') {
        return items
            .filter((item) => item.salesOrg !== 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'tissue') {
        return items
            .filter((item) => item.salesOrg === 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'accOwned') {
        return items
            .filter((item) => item.accountOwned)
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    }
    return [];
};

export const isPriceOverrideApplyBtnDisabled = (
    priceOverrideReason,
    priceOverrideTableData
) => {
    return (
        (priceOverrideReason && priceOverrideReason.length > 0
            ? !priceOverrideTableData.some(
                  (item) =>
                      item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice
              )
            : false) ||
        (priceOverrideTableData.some(
            (item) =>
                !item.invalidOtherQtyAdjBasePriceMsg &&
                !item.invalidUsedQtyAdjBasePriceMsg &&
                (item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice)
        )
            ? !(priceOverrideReason && priceOverrideReason.length > 0)
            : false) ||
        priceOverrideTableData.some(
            (item) =>
                item.invalidOtherQtyAdjBasePriceMsg ||
                item.invalidUsedQtyAdjBasePriceMsg
        )
    );
};

export const checkIfValidProductsInRecordScreen = (
    validProducts,
    itemTableData,
    patientDetails
) => {
    const validProductsCfn = validProducts.map((x) => x.productCFN);
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every((item) =>
            !item.isInvalidItemMsg &&
            validProductsCfn.includes(item.cfn) &&
            item.lotSerial.every(
                (x) => x.isInvalidLotSerialMsg === null && !x.isInvalidQtyMsg
            ) &&
            item.isBundleItem
                ? item.children &&
                  item.children.every(
                      (child) =>
                          !child.isInvalidItemMsg &&
                          validProductsCfn.includes(child.cfn) &&
                          child.lotSerial.every(
                              (x) =>
                                  x.isInvalidLotSerialMsg === null &&
                                  !x.isInvalidQtyMsg
                          )
                  )
                : !item.children
        ) &&
        checkIfValidPricedItems(itemTableData) &&
        patientDetails &&
        patientDetails.hrefId.length > 0
    );
};
export const checkIfValidReportPayment = (validProducts, itemTableData) => {
    const validProductsCfn = validProducts.map((x) => x.productCFN || x.cfn);

    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every(
            (item) => {
                return (
                    !item.isInvalidItemMsg &&
                    validProductsCfn.includes(item.cfn || item.productCFN) &&
                    // item.lotSerial.every(
                    //     (x) => x.isInvalidLotSerialMsg === null && !x.isInvalidQtyMsg
                    // )
                    !item.isInvalidLotSerialMsg &&
                    !item.isInvalidQtyMsgs
                );
            }

            // item.isBundleItem
            //     ? item.children &&
            //       item.children.every(
            //           (child) =>
            //               !child.isInvalidItemMsg &&
            //               validProductsCfn.includes(child.cfn) &&
            //               child.lotSerial.every(
            //                   (x) =>
            //                       x.isInvalidLotSerialMsg === null &&
            //                       !x.isInvalidQtyMsg
            //               )
            //       )
            //     : !item.children
        )

        //need to Ask
        // checkIfValidPricedItems(itemTableData) &&
        // patientDetails &&
        // patientDetails.hrefId.length > 0
    );
};

export const getPatientDetailsInDraftOrder = (patientDetails) => {
    return {
        hrefId: patientDetails.hrefId ? patientDetails.hrefId : '',
        patientDOB: patientDetails.patientDOB
            ? convertDateToISOString(patientDetails.patientDOB, 'original')
            : '',
        patientFirstName: patientDetails.patientFirstName
            ? patientDetails.patientFirstName
            : '',
        patientLastName: patientDetails.patientLastName
            ? patientDetails.patientLastName
            : '',
        patientSex: patientDetails.patientSex ? patientDetails.patientSex : '',
    };
};

const generateSingleItemObj = (
    item,
    replenData,
    qtyArr,
    lotSerialObj,
    isChildItem,
    exisitingFormObject
) => {
    const qtyType = qtyArr && qtyArr[0] && qtyArr[0].toLowerCase();
    const singleItemObj = { productCFN: item.cfn, isReplenish: false };
    if (item.salesOrg) {
        singleItemObj.salesOrg = item.salesOrg;
    }
    if (item.description) {
        singleItemObj.description = item.description;
    }
    if (item.uom) {
        singleItemObj.uom = item.uom;
    }
    if (lotSerialObj?.Serial) {
        singleItemObj.lotSerialNumber = lotSerialObj.Serial;
    }
    if (item.isUnidRodItem) {
        singleItemObj.isUnidRodItem = item.isUnidRodItem;
    }
    if ((qtyType === 'used' || qtyType === 'other') && qtyArr[1]) {
        singleItemObj[
            isChildItem
                ? 'quantity'
                : qtyType === 'other'
                ? 'otherQuantity'
                : 'usedQuantity'
        ] = qtyArr[1] === true ? '1' : qtyArr[1];
    }
    if (qtyType === 'used' && lotSerialObj?.usedQtyPayment) {
        singleItemObj.payment = lotSerialObj.usedQtyPayment;
    }
    if (qtyType === 'other' && lotSerialObj?.otherQtyPayment) {
        singleItemObj.payment = lotSerialObj.otherQtyPayment;
    }
    singleItemObj.isAccountOwned = item.accountOwned
        ? item.accountOwned
        : false;
    if (!isChildItem) {
        singleItemObj.isAdditionalCartEntry = false;
        if (item.basePrice) {
            singleItemObj.unitPrice = item.accountOwned
                ? '0.00'
                : getPriceInNumberDataType(item.basePrice);
        }
        if (qtyType === 'used' && item.adjustedUsedQtyPrice) {
            singleItemObj.overrideUnitPrice = item.adjustedUsedQtyPrice;
        } else if (qtyType === 'other' && item.adjustedOtherQtyPrice) {
            singleItemObj.overrideUnitPrice = item.adjustedOtherQtyPrice;
        }
    }
    if (exisitingFormObject?.products?.length > 0) {
        const existingItem = exisitingFormObject?.products?.filter((existing) => {
            const isQtyflag = Object.keys(existing).includes(
                `${qtyType}Quantity`
            );
            return (
                existing.productCFN === item.cfn &&
                existing.lotSerial?.filter(
                    (x) => x.Serial === lotSerialObj?.Serial
                )?.length > 0 &&
                existing.payment &&
                Object.keys(existing.payment).length > 0 &&
                isQtyflag
            );
        });
        if (existingItem?.length > 0) {
            singleItemObj.payment = existingItem[0]?.payment;
            if (existingItem[0].isAdditionalCartEntry) {
                singleItemObj.isAdditionalCartEntry =
                    existingItem[0]?.isAdditionalCartEntry;
            }
        }
        const getAditionalCartEntry = exisitingFormObject?.products?.filter(
            (existing) =>
                existing.productCFN === item.cfn &&
                existing.isAdditionalCartEntry
        );
        if (getAditionalCartEntry?.length > 0) {
            singleItemObj.isAdditionalCartEntry =
                getAditionalCartEntry[0]?.isAdditionalCartEntry;
        }
    }
    const isValidQty =
        (isChildItem && singleItemObj.quantity) ||
        singleItemObj.usedQuantity ||
        singleItemObj.otherQuantity;
    if (
        !item.accountOwned &&
        replenData &&
        replenData.length > 0 &&
        replenData.map((x) => x.cfn).includes(item.cfn) &&
        isValidQty
    ) {
        const replenItemIdx = replenData.findIndex((x) => x.cfn === item.cfn);
        if (replenItemIdx >= 0 && replenData[replenItemIdx].shippingDetails) {
            singleItemObj.isReplenish = true;
            const shippingDetails = replenData[replenItemIdx].shippingDetails;
            singleItemObj.replenishmentDetails = {};
            if (
                shippingDetails.accountDetails &&
                shippingDetails.accountDetails.accountId
            ) {
                singleItemObj.replenishmentDetails.accountId =
                    shippingDetails.accountDetails.accountId;
            }
            if (
                shippingDetails.shippingAddress &&
                shippingDetails.shippingAddress.shippingAddressId
            ) {
                singleItemObj.replenishmentDetails.shipTo =
                    shippingDetails.shippingAddress.shippingAddressId;
            }
            if (
                shippingDetails.shippingMethod &&
                shippingDetails.shippingMethod.shippingMethodId
            ) {
                singleItemObj.replenishmentDetails.shippingMethodId =
                    shippingDetails.shippingMethod.shippingMethodId;
            }
            if (shippingDetails.attnLine) {
                singleItemObj.replenishmentDetails.attentionLine =
                    shippingDetails.attnLine;
            }
        }
    }

    return singleItemObj;
};

const getProductsInDraftOrder = (
    itemTableData,
    replenData,
    exisitingFormObject
) => {
    const productsArr = [];
    itemTableData.forEach((item) => {
        let itemObj = {};
        item.lotSerial &&
            item.lotSerial.forEach((lotSerialObj) => {
                const quantityArr = Object.entries(lotSerialObj).filter(
                    (objArr) => objArr[0] === 'used' || objArr[0] === 'other'
                );
                if (quantityArr?.length === 2) {
                    const usedQtyIdx = quantityArr.findIndex(
                        (x) => x[0] === 'used'
                    );
                    const otherQtyIdx = quantityArr.findIndex(
                        (x) => x[0] === 'other'
                    );
                    if (
                        (!quantityArr[0][1] && !quantityArr[1][1]) ||
                        (quantityArr[usedQtyIdx][1] &&
                            !quantityArr[otherQtyIdx][1])
                    ) {
                        quantityArr.splice(otherQtyIdx, 1);
                    } else if (
                        quantityArr[otherQtyIdx][1] &&
                        !quantityArr[usedQtyIdx][1]
                    ) {
                        quantityArr.splice(usedQtyIdx, 1);
                    }
                }
                if (quantityArr?.length > 0) {
                    quantityArr.forEach((qtyArr) => {
                        itemObj = generateSingleItemObj(
                            item,
                            replenData,
                            qtyArr,
                            lotSerialObj,
                            false,
                            exisitingFormObject
                        );
                        if (Object.keys(itemObj).length > 0)
                            productsArr.push(itemObj);
                    });
                }
            });
        if (item.isBundleItem && item.children && item.children.length > 0) {
            const bundleItemsArr = [];
            item.children.forEach((child) => {
                let childItemObj = {};
                child.lotSerial &&
                    child.lotSerial.forEach((childLotSerial) => {
                        const childQtyArr = Object.entries(
                            childLotSerial
                        ).filter(
                            (objArr) =>
                                objArr[0] === 'Used' || objArr[0] === 'used'
                        );
                        if (childQtyArr && childQtyArr.length > 0) {
                            childQtyArr.forEach((qtyArr) => {
                                childItemObj = generateSingleItemObj(
                                    child,
                                    replenData,
                                    qtyArr,
                                    childLotSerial,
                                    true,
                                    exisitingFormObject
                                );
                                if (Object.keys(childItemObj).length > 0)
                                    bundleItemsArr.push(childItemObj);
                            });
                        }
                    });
            });
            if (bundleItemsArr.length > 0) {
                itemObj.bundleItem = bundleItemsArr;
            }
        }
    });
    return productsArr;
};

export const createRecordAndReplenDraftOrderObj = (
    usageDetails,
    patientDetails,
    itemTableData,
    replenishData,
    myCaseResourceType,
    exisitingFormObject
) => {
    let draftOrderObj = {};
    if (usageDetails && Object.keys(usageDetails).length > 0) {
        draftOrderObj.myCaseRef = usageDetails.myCaseRef;
        draftOrderObj.procedureCode = exisitingFormObject.procedureCode
            ? exisitingFormObject.procedureCode
            : usageDetails.procedureCode;
        draftOrderObj.physicianId = exisitingFormObject.physicianId
            ? exisitingFormObject.physicianId
            : usageDetails.physicianId;
        draftOrderObj.isSapSubmission = false;
        draftOrderObj.isReportPayment = myCaseResourceType === 'reportPayment';
    }
    if (patientDetails && Object.keys(patientDetails).length > 0) {
        const patientDetailsObj = getPatientDetailsInDraftOrder(patientDetails);
        if (Object.keys(patientDetailsObj).length > 0)
            draftOrderObj = { ...draftOrderObj, ...patientDetailsObj };
    }
    const productsArr = getProductsInDraftOrder(
        itemTableData?.length > 0 ? itemTableData : [],
        replenishData,
        exisitingFormObject
    );
    draftOrderObj = {
        ...draftOrderObj,
        products: productsArr?.length > 0 ? productsArr : [],
    };
    return draftOrderObj;
};

export const checkIfValidProcedureData = (procedureInfoData) => {
    return Object.entries(procedureInfoData).every((objArr) => {
        if (objArr[1] instanceof Array) {
            if (objArr[0] === 'additionalProcedure') {
                return objArr[1].every((item) =>
                    item.description === t('equity.common.utils.mazorX') &&
                    item.isSelected
                        ? item.mazorKitCode && item.mazorKitCode.length > 0
                        : typeof item.isSelected === 'boolean'
                );
            } else if (objArr[0] === 'biologicsDetail') {
                return true;
            } else {
                return objArr[1].some((x) => x.isSelected);
            }
        } else {
            return objArr[1] && objArr[1].length > 0;
        }
    });
};

const getAdditionalProcedureObj = (additionalProcedureData) => {
    const additionalProcedureObj = {};
    if (
        typeof additionalProcedureData.find(
            (x) => x.description === t('equity.common.utils.powerease')
        ).isSelected === 'boolean'
    ) {
        additionalProcedureObj.isPowerease = additionalProcedureData.find(
            (x) => x.description === t('equity.common.utils.powerease')
        ).isSelected;
    }
    const mazorxRobotics = additionalProcedureData.find(
        (x) => x.description === t('equity.common.utils.mazorX')
    );
    if (typeof mazorxRobotics.isSelected === 'boolean') {
        additionalProcedureObj.isMazorXRoboticsUsed = mazorxRobotics.isSelected;
        if (mazorxRobotics.isSelected)
            additionalProcedureObj.mazorKitCode = mazorxRobotics.mazorKitCode
                ? mazorxRobotics.mazorKitCode
                : '';
    }
    if (
        typeof additionalProcedureData.find(
            (x) => x.description === t('equity.common.utils.navigation')
        ).isSelected === 'boolean'
    ) {
        additionalProcedureObj.isNavigaton = additionalProcedureData.find(
            (x) => x.description === t('equity.common.utils.navigation')
        ).isSelected;
    }
    return additionalProcedureObj;
};

export const createProcedureDraftOrderObject = (procedureData) => {
    const procedureObj = {};
    if (
        procedureData.additionalProcedure &&
        procedureData.additionalProcedure.some(
            (x) => typeof x.isSelected === 'boolean'
        ) &&
        Object.keys(
            getAdditionalProcedureObj(procedureData.additionalProcedure)
        ).length > 0
    ) {
        procedureObj.additionProcedure = getAdditionalProcedureObj(
            procedureData.additionalProcedure
        );
    }
    if (
        procedureData.therapies &&
        procedureData.therapies.some((x) => x.isSelected)
    ) {
        procedureObj.physicianFinderEligibility = procedureData.therapies
            .filter((x) => x.isSelected)
            .map((y) => y.code);
    }
    if (procedureData.technologies) {
        const selectedTechnology = procedureData.technologies.find(
            (x) => x.isSelected
        );
        if (selectedTechnology) {
            procedureObj.deformityCorrectionCode = selectedTechnology.code;
        }
    }
    if (
        procedureData.biologicsUsed &&
        procedureData.biologicsUsed.some((x) => x.isSelected)
    ) {
        procedureObj.biologicsUsed = procedureData.biologicsUsed
            .filter((x) => x.isSelected)
            .map((y) => y.code);

        if (
            procedureData.biologicsDetail &&
            procedureData.biologicsUsed.find((x) => x.code === '02').isSelected
        ) {
            if (
                procedureData.biologicsDetail.some((x) => x.isMedtronicSelected)
            ) {
                procedureObj.medtronicSupp = procedureData.biologicsDetail
                    .filter((x) => x.isMedtronicSelected)
                    .map((y) => y.code);
            }
            if (
                procedureData.biologicsDetail.some(
                    (x) => x.isCompetitiveSelected
                )
            ) {
                procedureObj.compatitiveSupp = procedureData.biologicsDetail
                    .filter((x) => x.isCompetitiveSelected)
                    .map((y) => y.code);
            }
        }
    }
    return procedureObj;
};

export const generateUnidInfoRequestObject = (unidSurgeryInfo) => {
    const unidSurgeryInfoObject = {};
    const unidItems = unidSurgeryInfo.unidProducts.filter(
        (item) => item.productCFN !== 'None' && item.isChecked
    );
    unidSurgeryInfoObject.items = unidItems
        ? unidItems.map((x) => x.productCFN)
        : [];
    unidSurgeryInfoObject.isAsMainRod =
        unidSurgeryInfo.implantedAsMainRod === 'Yes';

    unidSurgeryInfoObject.asMainRodSurgicalPlan =
        unidSurgeryInfo.whyNotImplantedAsMainRod.find(
            (item) => item.id === 1
        ).isChecked;
    unidSurgeryInfoObject.asMainRodLengthOrContour =
        unidSurgeryInfo.whyNotImplantedAsMainRod.find(
            (item) => item.id === 2
        ).isChecked;

    unidSurgeryInfoObject.isSurgeonChangedSurgicalPlan =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 1
        ).isChecked;

    unidSurgeryInfoObject.isIssueWithLengthOrContour =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 2
        ).isChecked;

    unidSurgeryInfoObject.isSalesOperations =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 3
        ).isChecked;
    unidSurgeryInfoObject.salesOperationsText =
        unidSurgeryInfo.whyAllRodsNotImplanted.find((item) => item.id === 3)
            .isChecked
            ? unidSurgeryInfo.reasonText
            : '';

    unidSurgeryInfoObject.isManufacturingIssue =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 4
        ).isChecked;
    unidSurgeryInfoObject.manufacturingIssueText =
        unidSurgeryInfo.whyAllRodsNotImplanted.find((item) => item.id === 4)
            .isChecked
            ? unidSurgeryInfo.reasonText
            : '';

    unidSurgeryInfoObject.isNotDeliveredOnTime =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 5
        ).isChecked;

    unidSurgeryInfoObject.isMultipleVersions =
        unidSurgeryInfo.whyAllRodsNotImplanted.find(
            (item) => item.id === 6
        ).isChecked;

    return unidSurgeryInfoObject;
};

export const generateORreportRequestObject = (orReportQuestionsObj) => {
    const ORreportRequestObject = {};
    if (typeof orReportQuestionsObj.isSurgicalPlanChanged === 'boolean') {
        ORreportRequestObject.isSurgicalPlanChanged =
            orReportQuestionsObj.isSurgicalPlanChanged;
    }
    if (
        typeof orReportQuestionsObj.isLevelOfInstrumentationChanged ===
        'boolean'
    ) {
        ORreportRequestObject.isLevelOfInstrumentationChanged =
            orReportQuestionsObj.isLevelOfInstrumentationChanged;
        if (orReportQuestionsObj.isLevelOfInstrumentationChanged) {
            ORreportRequestObject.uiv = orReportQuestionsObj.uiv;
            ORreportRequestObject.liv = orReportQuestionsObj.liv;
        }
    }
    if (
        typeof orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs === 'boolean'
    ) {
        ORreportRequestObject.isChangeToInterbodiesAndOrPSOs =
            orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs;
        if (orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs) {
            ORreportRequestObject.anyChangeToInterbodiesAndOrPSOsTxt =
                orReportQuestionsObj.anyChangeToInterbodiesAndOrPSOsTxt;
        }
    }
    if (typeof orReportQuestionsObj.isSurgeonCutTheRod === 'boolean') {
        ORreportRequestObject.isSurgeonCutTheRod =
            orReportQuestionsObj.isSurgeonCutTheRod;
        if (orReportQuestionsObj.isSurgeonCutTheRod) {
            ORreportRequestObject.surgeonCutTheRodText =
                orReportQuestionsObj.surgeonCutTheRodText;
        }
    }
    if (typeof orReportQuestionsObj.isRodBentInSagittalPlan === 'boolean') {
        ORreportRequestObject.isRodBentInSagittalPlan =
            orReportQuestionsObj.isRodBentInSagittalPlan;
        if (orReportQuestionsObj.isRodBentInSagittalPlan) {
            ORreportRequestObject.rodBentInSagittalPlanTxt =
                orReportQuestionsObj.rodBentInSagittalPlanTxt;
        }
    }
    if (typeof orReportQuestionsObj.isSurgeonSatisfied === 'boolean') {
        ORreportRequestObject.isSurgeonSatisfied =
            orReportQuestionsObj.isSurgeonSatisfied;
    }
    return ORreportRequestObject;
};
export const createFormDataOFRP = (
    reportPaymentGridData,
    formObjectProduct
) => {
    const formArray = reportPaymentGridData.map((item) => {
        let newObject = {};
        if (item.isAdditionalCartEntry) {
            newObject = {
                isAdditionalCartEntry: item.isAdditionalCartEntry,
                isReplenish: false,
                productCFN: item.productCFN,
                salesOrg: item.salesOrg,
                isAccountOwned: false,
            };
            if (item.description) {
                newObject.description = item.description;
            }
            if (item.lotSerialNumber) {
                newObject.lotSerialNumber = item.lotSerialNumber;
            }
            if (item.unitPrice) {
                newObject.unitPrice = getPriceInNumberDataType(item.unitPrice);
            }
            if (item.uom) {
                newObject.uom = item.uom;
            }
            if (item.usedQuantity) {
                newObject.usedQuantity = item.usedQuantity;
            }
        } else {
            const temp = formObjectProduct.filter(
                (formObject) =>
                    formObject.productCFN === item.productCFN &&
                    (item?.usedQuantity
                        ? formObject.usedQuantity === item.usedQuantity
                        : formObject.otherQuantity === item.otherQuantity)
            );
            if (temp.length > 0) {
                newObject = {
                    ...temp[0],
                    isAdditionalCartEntry: false,
                };
            }
        }
        if (item.payment) {
            newObject.payment = {
                poNumber: item.payment.poNumber,
            };
            if (item.payment?.poAttachment) {
                newObject.payment = {
                    ...newObject.payment,
                    poAttachment: item.payment.poAttachment,
                };
            }
        } else {
            delete newObject.payment;
        }
        return newObject;
    });
    return formArray;
};
